export default "__VITE_IMAGE_ASSET__afd483dc__";